import axios from 'axios';

// Cache for issue fields to avoid repeated API calls
let cachedIssueFields = null;
let fetchPromise = null;

export const getIssueFields = async () => {
  // Return cached version if available
  if (cachedIssueFields) {
    return cachedIssueFields;
  }

  // Return existing promise if already fetching
  if (fetchPromise) {
    return fetchPromise;
  }

  // Create new fetch promise
  fetchPromise = axios.get('/api/admin/issue-fields')
    .then(response => {
      cachedIssueFields = response.data;
      fetchPromise = null;
      return cachedIssueFields;
    })
    .catch(error => {
      fetchPromise = null;
      console.error('Error fetching issue fields:', error);
      // Return fallback fields
      return [
        {
          system_name: 'name',
          display_name: 'Issue Name',
          field_type: 'text',
          required: true
        },
        {
          system_name: 'description',
          display_name: 'Description',
          field_type: 'textarea',
          required: true
        },
        {
          system_name: 'rating',
          display_name: 'Rating',
          field_type: 'select',
          options: [
            { value: 'CRITICAL', label: 'Critical' },
            { value: 'HIGH', label: 'High' },
            { value: 'MEDIUM', label: 'Medium' },
            { value: 'LOW', label: 'Low' }
          ]
        },
        {
          system_name: 'status',
          display_name: 'Status',
          field_type: 'select',
          options: [
            { value: 'OPEN', label: 'Open' },
            { value: 'IN_PROGRESS', label: 'In Progress' },
            { value: 'CLOSED', label: 'Closed' }
          ]
        }
      ];
    });

  return fetchPromise;
};

// Clear cache function for when fields are updated
export const clearIssueFieldsCache = () => {
  cachedIssueFields = null;
  fetchPromise = null;
};

// Default issue fields constant (fallback)
export const DEFAULT_ISSUE_FIELDS = [
  {
    system_name: 'name',
    display_name: 'Issue Name',
    field_type: 'text',
    required: true
  },
  {
    system_name: 'description',
    display_name: 'Description',
    field_type: 'textarea',
    required: true
  },
  {
    system_name: 'rating',
    display_name: 'Rating',
    field_type: 'select',
    options: [
      { value: 'CRITICAL', label: 'Critical' },
      { value: 'HIGH', label: 'High' },
      { value: 'MEDIUM', label: 'Medium' },
      { value: 'LOW', label: 'Low' }
    ]
  },
  {
    system_name: 'status',
    display_name: 'Status',
    field_type: 'select',
    options: [
      { value: 'OPEN', label: 'Open' },
      { value: 'IN_PROGRESS', label: 'In Progress' },
      { value: 'CLOSED', label: 'Closed' }
    ]
  },
  {
    system_name: 'identification_method',
    display_name: 'Identification Method',
    field_type: 'select',
    options: [
      { value: 'AUTOMATED', label: 'Automated Detection' },
      { value: 'MANUAL', label: 'Manual Review' },
      { value: 'AUDIT', label: 'Audit Finding' },
      { value: 'INCIDENT', label: 'Incident Response' }
    ]
  },
  {
    system_name: 'date_identified',
    display_name: 'Date Identified',
    field_type: 'date',
    required: true
  },
  {
    system_name: 'rationale_for_rating',
    display_name: 'Rationale for Rating',
    field_type: 'textarea'
  },
  {
    system_name: 'impacted_products',
    display_name: 'Impacted Products',
    field_type: 'text'
  },
  {
    system_name: 'impacted_teams',
    display_name: 'Impacted Teams',
    field_type: 'text'
  },
  {
    system_name: 'impacted_licensed_entities',
    display_name: 'Impacted Licensed Entities',
    field_type: 'text'
  }
]; 